import React from "react";

interface Props {
    contentLeft: JSX.Element;
    contentRight: JSX.Element;
}

const AdminDashboardTwoColumnLayout = (props: Props) => {
    const {contentLeft, contentRight} = props;
    return (
        <div className="AdminDashboardTwoColumnLayout relative h-full flex bg-white rounded-3xl m-8 flex-row justify-start max-h-screen content-between items-stretch">
            <div className="flex-grow grid xl:grid-cols-2 gap-8 m-8 overflow-y-auto max-h-full items-stretch justify-items-stretch">{contentLeft}</div>
            <div className="flex py-8 pr-2 flex-shrink-0 max-w-xs min-w-xs w-60 xl:w-auto justify-items-stretch items-start content-between flex-col">
                <div className="gap-8 flex flex-col w-full h-full">{contentRight}</div>
            </div>
        </div>
    );
};

export default AdminDashboardTwoColumnLayout;
